/**
 * @flow
 * @relayHash ce48b6d2904ef4a334d8a2a395c4b9d4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SellerGroupModelList_searchSeller$ref = any;
export type SellerGroupModelListLoaderQueryVariables = {||};
export type SellerGroupModelListLoaderQueryResponse = {|
  +searchSeller: ?{|
    +$fragmentRefs: SellerGroupModelList_searchSeller$ref
  |}
|};
export type SellerGroupModelListLoaderQuery = {|
  variables: SellerGroupModelListLoaderQueryVariables,
  response: SellerGroupModelListLoaderQueryResponse,
|};
*/


/*
query SellerGroupModelListLoaderQuery {
  searchSeller {
    ...SellerGroupModelList_searchSeller
  }
}

fragment SellerGroupModelList_searchSeller on SearchSeller {
  searchSellerGroup(offset: 1, limit: 10, sellerModelNumber: "", specs: "", stocks: "", price: "", shippingDate: "") {
    models {
      sellerProductGroupId
      sellerProductGroupName
      sellerModelId
      sellerContactId
      sellerModelNumber
      price
      stocks
      shippingDate
      salesMethodMaker
      openPrice
      salesMethod
      salesMethodLabel
      specs {
        specId
        specName
        specValue
      }
      groupSpecs {
        specId
        specName
        specValue
      }
      allModelSpecsIsPresentInGroup
    }
    groups {
      sellerProductGroupId
      sellerProductGroupName
      sellerModelId
    }
    pageMetadata {
      totalRecords
      currentPage
      recordsFrom
      recordsTo
      noOfPages
      took
      prevPage
      nextPage
      maxNoOfPageToDisplay
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerProductGroupId",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerProductGroupName",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerModelId",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specId",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specValue",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SellerGroupModelListLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "searchSeller",
        "storageKey": null,
        "args": null,
        "concreteType": "SearchSeller",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SellerGroupModelList_searchSeller",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SellerGroupModelListLoaderQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "searchSeller",
        "storageKey": null,
        "args": null,
        "concreteType": "SearchSeller",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchSellerGroup",
            "storageKey": "searchSellerGroup(limit:10,offset:1,price:\"\",sellerModelNumber:\"\",shippingDate:\"\",specs:\"\",stocks:\"\")",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 10
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "price",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "sellerModelNumber",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "shippingDate",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "specs",
                "value": ""
              },
              {
                "kind": "Literal",
                "name": "stocks",
                "value": ""
              }
            ],
            "concreteType": "SellerGroupProduct",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "models",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerGroupProductModel",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellerContactId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellerModelNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "stocks",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shippingDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesMethodMaker",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "openPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesMethod",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesMethodLabel",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "specs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerGroupProductModelSpec",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "groupSpecs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerGroupProductModelSpec",
                    "plural": true,
                    "selections": (v3/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "allModelSpecsIsPresentInGroup",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "groups",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerGroupProductModelGroup",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageMetadata",
                "storageKey": null,
                "args": null,
                "concreteType": "PageMetadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalRecords",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currentPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recordsFrom",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recordsTo",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "noOfPages",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "took",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "prevPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "nextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "maxNoOfPageToDisplay",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SellerGroupModelListLoaderQuery",
    "id": null,
    "text": "query SellerGroupModelListLoaderQuery {\n  searchSeller {\n    ...SellerGroupModelList_searchSeller\n  }\n}\n\nfragment SellerGroupModelList_searchSeller on SearchSeller {\n  searchSellerGroup(offset: 1, limit: 10, sellerModelNumber: \"\", specs: \"\", stocks: \"\", price: \"\", shippingDate: \"\") {\n    models {\n      sellerProductGroupId\n      sellerProductGroupName\n      sellerModelId\n      sellerContactId\n      sellerModelNumber\n      price\n      stocks\n      shippingDate\n      salesMethodMaker\n      openPrice\n      salesMethod\n      salesMethodLabel\n      specs {\n        specId\n        specName\n        specValue\n      }\n      groupSpecs {\n        specId\n        specName\n        specValue\n      }\n      allModelSpecsIsPresentInGroup\n    }\n    groups {\n      sellerProductGroupId\n      sellerProductGroupName\n      sellerModelId\n    }\n    pageMetadata {\n      totalRecords\n      currentPage\n      recordsFrom\n      recordsTo\n      noOfPages\n      took\n      prevPage\n      nextPage\n      maxNoOfPageToDisplay\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8702a8d6d338bafb7270199b88f2a539';
module.exports = node;
